export const numberUtil = {
  formatNumber: (value: number | string): string => {
    const numericValue = typeof value === 'number' ? value : Number(value) || 0
    return numericValue.toLocaleString('en-US')
  },
}
